<template>
  <fragment v-if="isLoaded">
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid">
          <slot name="header"></slot>
          <div class="row myrow">
            <div class="col-xs-12 mycol header-title">
              <div class="col-xs-12 mycol">
                <div class="h-t-name pull-left">Реестр экспертиз</div>
                <div class="pull-right">
                  <p
                    class="h-t-status-link"
                    style="padding-right: 40px;padding-top: 5px;float: left"
                  >
                    <a
                      title="Выгрузить реестр экспертиз"
                      @click="getLinkExpertise"
                      class="xls"
                    ></a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mycontainer-fluid content content_table">
          <div class="wrapper-header">
            <form
              v-if="allExpertises && allExpertises.SETTINGS"
              v-on:submit.prevent="fetchExpertise"
            >
              <div class="row myrow project-filter filter-wrapper-stl">
                <!--      Заемщик        -->
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <input
                    id="zaemschik"
                    type="text"
                    class="filter-input-stl"
                    placeholder="Организация"
                    v-model="filter.companyName"
                  />
                </div>

                <!--      Номер проекта        -->
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <input
                    id="project_number"
                    type="text"
                    class="filter-input-stl"
                    placeholder="Номер проекта"
                    v-model="filter.projectNumber"
                  />
                </div>

                <!--    Вид экспертизы    -->
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <Multiselect
                    label="NAME"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.expertiseVid"
                    :options="getTimeStatusCreateSP"
                    :multiple="true"
                    placeholder="Вид экспертизы"
                  >
                    <span slot="noResult">Записи не найдены</span>
                  </Multiselect>
                </div>

                <!--    Тип экспертизы    -->
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <Multiselect
                    label="CODE_NAME"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.expertiseType"
                    :options="getTypeSp"
                    :multiple="true"
                    placeholder="Тип экспертизы"
                  >
                    <span slot="noResult">Записи не найдены</span>
                  </Multiselect>
                </div>

                <!--    Тип экспертизы    -->
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <Multiselect
                    label="UF_NAME"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.expertiseSubType"
                    :options="getSubTypeSp"
                    :multiple="true"
                    placeholder="Подтип экспертизы"
                  >
                    <span slot="noResult">Записи не найдены</span>
                  </Multiselect>
                </div>

                <!--    Эксперты    -->
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <Multiselect
                    label="NAME"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.experts"
                    :options="getListExperts"
                    :multiple="true"
                    :disabled="!!allExpertises.SETTINGS.IS_BLOCK_PHILTER_EXPERT"
                    placeholder="Эксперты"
                  >
                    <span slot="noOptions">Список пуст</span>
                    <span slot="noResult">Пользователи не найдены</span>
                  </Multiselect>
                </div>

                <!--  Сотрудник ОСП  -->
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  v-if="
                    allExpertises.SETTINGS &&
                      allExpertises.SETTINGS.IS_VIEW_PHILTER_MANAGER_OSP
                  "
                >
                  <Multiselect
                    label="NAME"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.manager_osp"
                    :options="allExpertises.SETTINGS.MANAGER_OSP_LIST"
                    :multiple="true"
                    placeholder="Менеджер сопровождения"
                  />
                </div>

                <!--    Статус экспертизы    -->
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <Multiselect
                    label="NAME"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.expertiseStatus"
                    :options="allExpertises.SETTINGS.STATUS_SP"
                    :multiple="true"
                    placeholder="Статус экспертизы"
                  >
                    <span slot="noResult">Записи не найдены</span>
                  </Multiselect>
                </div>
                <div class="stl-df-ac" style="width: 394px;">
                  <div
                    class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  >
                    <button
                      type="button"
                      class="project-filter__butt-btn butt-new-style butt-new-style-reset stl-w-full"
                      v-on:click="clearFilter"
                    >
                      СБРОС
                    </button>
                  </div>
                  <div
                    class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  >
                    <button
                      class="project-filter__butt-btn butt-new-style stl-w-full"
                      type="submit"
                      v-on:click="
                        isSendFilter = true;
                        fetchExpertise;
                      "
                    >
                      Поиск
                    </button>
                  </div>
                </div>
              </div>
              <!--div class="row myrow clearfix project-filter__butt">
            </div-->
            </form>
          </div>
          <!--    Таблица всех экспертиз      -->
          <div class="table-responsive container-stl" v-if="!isAllExpLoading">
            <table class="table table-hover table-striped table-new-style">
              <thead>
              <tr>
                <th class="text-nowrap">Карточка экспертизы</th>
                <th class="text-nowrap">Организация</th>
                <th class="text-nowrap">Проект</th>
                <th class="text-nowrap">
                  Дата
                  <a
                    @click="setOrder('UF_DATE_CREATE')"
                    class="sort"
                    :class="{
                        desc:
                          (sortColumn === 'UF_DATE_CREATE' &&
                            sortOrder === 'DESC') ||
                          sortColumn == ''
                      }"
                  />
                </th>
                <th class="text-nowrap">Инициатор экспертизы</th>
                <th class="text-nowrap">Вид экспертизы</th>
                <th class="text-nowrap">Тип экспертизы</th>
                <th class="text-nowrap">Подтип экспертизы</th>
                <th class="text-nowrap">Эксперт</th>
                <th class="text-nowrap">Статус</th>
                <th class="text-nowrap">
                  Крайний срок
                  <a
                    @click="setOrder('UF_DEADLINE_EXPERT_DATE')"
                    class="sort"
                    :class="{
                        desc:
                          sortColumn === 'UF_DEADLINE_EXPERT_DATE' &&
                          sortOrder === 'DESC'
                      }"
                  />
                </th>
                <th class="text-nowrap">Запросы</th>
              </tr>
              </thead>
              <tbody v-if="allExpertises && allExpertises.counts">
              <tr
                class="new"
                unselectable="on"
                style="cursor: default"
                v-for="proj in allExpertises.items"
                :key="proj.ID"
              >
                <td>
                  <router-link
                    :to="{
                        name: 'ExpertiseDetails',
                        params: { id: proj.UF_PROJECT_ID, expertiseId: proj.ID }
                      }"
                    target="_blank"
                    class="project-filter__butt-btn butt-new-style butt-new-style-reest"
                  >перейти
                  </router-link>
                </td>
                <td>{{ proj.COMPANY.NAME }}</td>
                <td>{{ proj.UF_NUMBER }}</td>
                <td>{{ proj.UF_DATE_CREATE }}</td>
                <td>{{ proj.CREATED_BY.NAME }}</td>
                <td>
                  <template v-if="proj.UF_DEMAND_URL">
                    <a :href="proj.UF_DEMAND_URL" target="_blank">{{
                        proj.VID_EXPERTISE_NAME
                      }}</a>
                  </template>
                  <template v-else>
                    <router-link
                      v-if="proj.VID_EXPERTISE_NAME"
                      :to="{ path: proj.VID_EXPERTISE_LINK }"
                      target="_blank"
                      style="color: #002333; text-decoration-line: underline;"
                    >{{ proj.VID_EXPERTISE_NAME }}
                    </router-link>
                  </template>
                </td>
                <td>
                  <template v-if="proj.UF_DEMAND_URL">
                    <a :href="proj.UF_DEMAND_URL" target="_blank">{{
                        proj.TYPE_EXPERTISE_NAME
                      }}</a>
                  </template>
                  <template v-else>
                    <router-link
                      v-if="proj.TYPE_EXPERTISE_NAME"
                      :to="{ path: proj.TYPE_EXPERTISE_LINK }"
                      target="_blank"
                      style="color: #002333; text-decoration-line: underline;"
                    >{{ proj.TYPE_EXPERTISE_NAME }}
                    </router-link>
                  </template>
                </td>
                <td>{{ proj.SUB_TYPE_EXPERTISE_NAME }}</td>
                <td>
                  <div v-if="proj.IS_SET_RULES_EXPERT === 0">
                    {{ proj.EXPERT.NAME }}
                  </div>
                  <div v-else>
                    <div v-if="proj.IS_SET_EXPERT === 1">
                      <button
                        class="project-filter__butt-btn butt-new-style"
                        type="button"
                        @click="expertModalOpen(proj)"
                      >
                        Назначить
                      </button>
                    </div>
                    <div v-else>
                      <select
                        class="i-main-style sel-dropdown i-wid-100 select-new-style"
                        :value="proj.EXPERT.UF_EXPERT_ID"
                        @change="updateExpertsModalOpen(proj, $event)"
                      >
                        <option
                          v-for="item in allExpertises.SETTINGS.EXPERTS_SP"
                          :value="item.ID"
                          :key="item.ID"
                          v-text="item.NAME"
                        />
                      </select>
                    </div>
                  </div>
                </td>
                <td>{{ proj.STATUS_EXPERTISE_TEXT }}</td>
                <td>
                  <div v-if="proj.IS_SET_RULES_EXPERT === 0">
                    {{ proj.UF_DEADLINE_EXPERT_DATE }}
                  </div>
                  <div v-else>
                    <div v-if="proj.IS_SET_DEADLINE === 1">
                      <button
                        class="project-filter__butt-btn butt-new-style"
                        type="button"
                        @click="proj.IS_SET_DEADLINE = 0"
                      >
                        Указать
                      </button>
                    </div>
                    <div v-else class="datepicker-allexpertises">
                      <datepicker
                        :value="proj.UF_DEADLINE_EXPERT_DATE"
                        :language="ru"
                        :monday-first="true"
                        :highlighted="highlighted"
                        input-class="form-control"
                        @input="setDeadline(proj, $event)"
                        @selected="setDeadline(proj, $event)"
                        :disabled-dates="disabledDates"
                      />
                    </div>
                  </div>
                </td>
                <td class="cnt">
                  <a
                    v-if="proj.UF_EXPERTISE_TYPE_CODE === 'pre'"
                    class="info-holder-icon info-holder-icon-td"
                    @click="viewRequestByProject(proj.UF_PROJECT_ID)"
                  ></a>
                </td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td colspan="12">Экспертизы не найдены</td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <td colspan="12">
                  <div class="paging">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col-xs-6 mycol">
                          <Pagination
                            :pages="pages"
                            :currentPage.sync="currentPage"
                          ></Pagination>
                        </div>
                        <div class="col-xs-6 mycol">
                          <div class="pull-right page-total">
                              <span style="padding-right: 15px"
                              >Всего: {{ allExpertises.counts }}</span
                              >
                            <span>Выводить по</span>
                            <span>
                                <select
                                  class="page-select"
                                  v-model="itemsPerPage"
                                >
                                  <option value="20">20</option>
                                  <option value="40">40</option>
                                  <option value="100">100</option>
                                  <option value="500">500</option>
                                </select>
                              </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              </tfoot>
            </table>
          </div>
          <div v-else>
            <h3>Загрузка...</h3>
          </div>
        </div>
      </div>
    </div>

    <!--      Модальное окно назначения эксперта в таблице      -->
    <div
      class="modal fade in show"
      v-if="expert.showExpertSelector"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" style="z-index: 10000" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click="expertModalClose"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Назначение ответсвенного эксперта</h4>
          </div>
          <div class="modal-body">
            <div>Номер проекта: № {{ expert.project.UF_NUMBER }}</div>
            <div>Вид экспертизы: "{{ expert.project.VID_EXPERTISE_NAME }}"</div>
            <div>
              Тип экспертизы: "{{ expert.project.TYPE_EXPERTISE_NAME }}"
            </div>
            <div class="form-group">
              <label>Эксперт: &nbsp;</label>
              <select v-model="expert.UF_EXPERT_ID" class="form-control">
                <option
                  v-for="expertUser in allExpertises.SETTINGS.EXPERTS_SP"
                  v-if="
                    in_array(
                      expert.project.UF_EXPERTISE_TYPE_ID,
                      expertUser.TYPE_EXPERTISE
                    )
                  "
                  :value="expertUser.ID"
                  :key="expertUser.ID"
                >
                  {{ expertUser.NAME }}
                </option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="appointExpert"
            >
              Назначить
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="expertModalClose"
            >
              Отмена
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--  Модальное окно переназначения эксперта в таблице  -->
    <div
      class="modal fade in show"
      v-if="expert.showExpertUpdater"
      tabindex="-1"
      role="dialog"
    >
      <div style="z-index: 10000" class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click="expertModalClose"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Изменение ответсвенного эксперта</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              Вы действительно хотите по проекту №
              {{ expert.project.UF_NUMBER }}, тип экспертизы "{{
                expert.project.TYPE_EXPERTISE_NAME
              }}" изменить эксперта "{{ expert.project.EXPERT.NAME }}" на "{{
                allExpertises.SETTINGS.EXPERTS_SP.filter(
                  el => el.ID === expert.event
                )[0]["NAME"]
              }}"?
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="appointExpert"
            >
              Изменить
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="updateExpertsModalClose"
            >
              Отмена
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--  Модальное окно связанные запросы по проекту  -->
    <div
      class="modal fade in show"
      v-if="isViewRequestInfo"
      tabindex="-1"
      role="dialog"
    >
      <div style="z-index: 10000;" class="modal-dialog modal-dialog-lg modal-close-active modal-new-style" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click="isViewRequestInfo = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Связанные запросы по проекту</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <table class="table table-striped table-new-style">
                <thead>
                <tr>
                  <th>№ запроса</th>
                  <th>Инициатор</th>
                  <th>Дата создания</th>
                  <th>Статус запроса</th>
                  <th>Дата завершения</th>
                  <th>Тип запроса</th>
                  <th>Ответственный</th>
                </tr>
                </thead>
                <tbody v-if="requests && requests.counts">
                <tr v-for="request in requests.items">
                  <td>
                    <router-link
                      :to="{
                        name: 'RequestEdit',
                        params: { id: request.ID }
                      }"
                      class="row-table-black-link"
                      target="_blank"
                    >
                      {{ request.UF_NUMBER }}
                    </router-link>

                  </td>
                  <td>{{ request.INITIATOR.NAME }}</td>
                  <td>{{ request.UF_DATE_CREATE }}</td>
                  <td>{{ request.STATUS.NAME }}</td>
                  <td>{{ request.UF_DATE_COMPETION }}</td>
                  <td>{{ request.TYPE_NAME }}</td>
                  <td>{{ request.PERFORMER.NAME }}</td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr><td colspan="7">Запросы по проекту не найдены</td></tr>
                </tbody>
              </table>

            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="isViewRequestInfo = false"
            >
              Закрыть
            </button>
          </div>
        </div>
      </div>
    </div>

    <slot name="footer"></slot>
  </fragment>
</template>

<script>
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import Vue from "vue";
import {
  SET_MAIN_MENU,
  SET_IS_VIEW_ALL_EXPERTISE,
  FETCH_ALL_EXPERTISES_LIST,
  FETCH_REQUESTS
} from "@/store/actions.type";
import { ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Multiselect from "vue-multiselect";
import { ExpertiseService } from "@/common/api.service";
import { ru } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";

Vue.filter("toCurrency", function(value) {
  if (typeof value !== "number") {
    return value;
  }
  const formatter = new Intl.NumberFormat("ru-RU", {
    style: "decimal",
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

export default {
  name: "ExpertiseAll",
  title: "Реестр экспертиз",
  components: {
    Pagination,
    Multiselect,
    Datepicker
  },
  data() {
    return {
      ru: ru,
      siteUrl: "",
      itemsPerPage: 20,
      currentPage: 1,
      sortOrder: "",
      sortColumn: "",
      filter: {
        companyName: "",
        projectNumber: "",
        expertiseVid: [],
        expertiseType: [],
        expertiseSubType: [],
        expertiseStatus: [],
        experts: [],
        manager_osp: []
      },
      isSendFilter: false,
      expert: {
        showExpertSelector: false,
        showExpertUpdater: false,
        project: {},
        UF_EXPERT_ID: "",
        event: null
      },
      disabledDates: {
        to: new Date(2022, 0, 1)
      },
      highlighted: {
        dates: [
          // your date
          new Date()
        ]
      },
      isLoaded: false,
      isViewRequestInfo: false
    };
  },

  async mounted() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");

    await this.$store.dispatch(SET_MAIN_MENU, []);
    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      let navMainMenu = [];
      if (data.START_PAGE === "REESTR_PROJECTS") {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }

        if (data.IS_VIEW_REQUEST_MODULE) {
          navMainMenu.push({
            name: "Запросы",
            route: "Requests"
          });
        }

        /*if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг лизинговых компаний",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }*/
      } else {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }

        if (data.IS_VIEW_REQUEST_MODULE) {
          navMainMenu.push({
            name: "Запросы",
            route: "Requests"
          });
        }

        /*if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых <br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }*/
      }
      this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );
    });
    this.fetchExpertise();
  },

  computed: {
    ...mapGetters(["allExpertises", "isAllExpLoading", "requests"]),

    getTypeSp() {
      const arr = [];
      Object.keys(this.allExpertises.SETTINGS.TYPE_SP).forEach(el => {
        arr.push(this.allExpertises.SETTINGS.TYPE_SP[el]);
      });
      return arr;
    },

    getSubTypeSp() {
      const arr = [];
      Object.keys(this.allExpertises.SETTINGS.SUBTYPE_SP).forEach(el => {
        arr.push(this.allExpertises.SETTINGS.SUBTYPE_SP[el]);
      });
      return arr;
    },

    getListExperts() {
      if (this.filter.expertiseType.length > 0) {
        const arr = [];
        const arrID = [];
        Object.keys(this.allExpertises.SETTINGS.EXPERTS_SP).forEach(el => {
          Object.keys(this.filter.expertiseType).forEach(elType => {
            if (this.allExpertises.SETTINGS.EXPERTS_SP[el]["TYPE_EXPERTISE"]) {
              if (
                this.allExpertises.SETTINGS.EXPERTS_SP[el][
                  "TYPE_EXPERTISE"
                  ].includes(this.filter.expertiseType[elType].ID)
              ) {
                console.log(this.allExpertises.SETTINGS.EXPERTS_SP[el]);
                if (
                  !arrID.includes(this.allExpertises.SETTINGS.EXPERTS_SP[el].ID)
                ) {
                  arr.push(this.allExpertises.SETTINGS.EXPERTS_SP[el]);
                  arrID.push(this.allExpertises.SETTINGS.EXPERTS_SP[el].ID);
                }
              }
            }
          });
        });
        return arr;
      } else {
        return this.allExpertises.SETTINGS.EXPERTS_SP;
      }
    },

    getTimeStatusCreateSP() {
      const arr = [];
      Object.keys(this.allExpertises.SETTINGS.TIME_STATUS_CREATE_SP).forEach(
        el => {
          arr.push(this.allExpertises.SETTINGS.TIME_STATUS_CREATE_SP[el]);
        }
      );
      return arr;
    },

    listConfig() {
      const q = {
        page: this.currentPage,
        limit: this.itemsPerPage,
        filter: {},
        isSendFilter: this.isSendFilter
      };
      if (this.sortColumn !== "") {
        let sort = {
          column: "",
          order: ""
        };
        sort.column = this.sortColumn;
        sort.order = this.sortOrder;
        q.sort = sort;
      }

      if (this.filter.companyName.length > 0) {
        q.filter.COMPANY_NAME = this.filter.companyName;
      }
      if (this.filter.projectNumber.length > 0) {
        q.filter.UF_NUMBER = this.filter.projectNumber;
      }

      if (this.filter.manager_osp && this.filter.manager_osp.length > 0) {
        q.filter.UF_MANAGER_OSP = this.filter.manager_osp;
      }

      if (this.filter.expertiseVid && this.filter.expertiseVid.length) {
        q.filter.UF_TIME_STATUS_CREATE_ID = [];
        this.filter.expertiseVid.forEach(function(it) {
          if (it.ID > 0) {
            q.filter.UF_TIME_STATUS_CREATE_ID.push(it.ID);
          }
        }, this);
      }

      if (this.filter.expertiseType && this.filter.expertiseType.length) {
        q.filter.UF_EXPERTISE_TYPE_ID = [];
        this.filter.expertiseType.forEach(function(it) {
          if (it.ID > 0) {
            q.filter.UF_EXPERTISE_TYPE_ID.push(it.ID);
          }
        }, this);
      }

      if (this.filter.expertiseSubType && this.filter.expertiseSubType.length) {
        q.filter.UF_SUPTYPE_EXPERTISE_ID = [];
        this.filter.expertiseSubType.forEach(function(it) {
          if (it.ID > 0) {
            q.filter.UF_SUPTYPE_EXPERTISE_ID.push(it.ID);
          }
        }, this);
      }

      if (this.filter.expertiseStatus && this.filter.expertiseStatus.length) {
        q.filter.UF_EXPERT_STATUS_ID = [];
        this.filter.expertiseStatus.forEach(function(it) {
          if (it.ID) {
            q.filter.UF_EXPERT_STATUS_ID.push(it.ID);
          }
        }, this);
      }

      if (this.filter.experts && this.filter.experts.length) {
        q.filter.UF_EXPERT_ID = [];
        this.filter.experts.forEach(function(it) {
          if (it.ID > 0) {
            q.filter.UF_EXPERT_ID.push(it.ID);
          }
        }, this);
      }

      if (this.filter.manager_osp && this.filter.manager_osp.length) {
        q.filter.UF_MANAGER_OSP = [];
        this.filter.manager_osp.forEach(function(it) {
          if (it.ID > 0) {
            q.filter.UF_MANAGER_OSP.push(it.ID);
          }
        }, this);
      }

      return q;
    },

    pages() {
      if (
        this.isAllExpLoading ||
        !this.allExpertises.counts ||
        this.allExpertises.counts <= this.itemsPerPage
      ) {
        return [];
      }
      return [
        ...Array(
          Math.ceil(this.allExpertises.counts / this.itemsPerPage)
        ).keys()
      ].map(e => e + 1);
    }
  },

  watch: {
    currentPage(newValue) {
      this.listConfig.page = newValue;
      this.fetchExpertise();
    },
    itemsPerPage(newValue) {
      this.listConfig.limit = newValue;
      this.fetchExpertise();
    }
  },

  methods: {
    setDeadline(proj, event) {
      ExpertiseService.setDedlineExpertise(proj.UF_PROJECT_ID, proj.ID, {
        UF_DEADLINE_EXPERT_DATE: event
      }).then(({ data }) => {
        if (!data.error) {
          this.fetchExpertise();
        } else {
          this.$toasted.show(data.errorArr[0], {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        }
      }, this);
    },

    expertModalOpen(proj) {
      this.expert.project = { ...proj };
      this.expert.showExpertSelector = true;
    },

    expertModalClose() {
      this.expert.project = {};
      this.expert.UF_EXPERT_ID = "";
      this.expert.showExpertSelector = false;
    },

    updateExpertsModalOpen(proj, event) {
      event.preventDefault();
      this.expert.project = { ...proj };
      this.expert.event = Number(event.target.value);
      this.expert.UF_EXPERT_ID = Number(event.target.value);
      this.expert.showExpertUpdater = true;
    },

    updateExpertsModalClose() {
      this.expert.project = {};
      this.expert.event = null;
      this.expert.UF_EXPERT_ID = "";
      this.expert.showExpertUpdater = false;
    },

    appointExpert() {
      ExpertiseService.addMainDocESExpertiseExpert(
        this.expert.project.UF_PROJECT_ID,
        this.expert.project.ID,
        {
          UF_EXPERT_ID: this.expert.UF_EXPERT_ID
        }
      ).then(({ data }) => {
        if (!data.error) {
          this.fetchExpertise();
        } else {
          this.$toasted.show(data.errorArr[0], {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        }
      }, this);
      this.expertModalClose();
      this.updateExpertsModalClose();
    },

    filterItemText(count) {
      console.log(count);
      return ``;
    },

    setOrder(column) {
      if (this.sortColumn !== column) {
        this.sortOrder = "ASC";
      } else {
        if (this.sortOrder === "DESC") {
          this.sortOrder = "ASC";
        } else {
          this.sortOrder = "DESC";
        }
      }
      this.sortColumn = column;
      this.fetchExpertise();
    },

    clearFilter() {
      this.filter = {
        companyName: "",
        projectNumber: "",
        expertiseVid: [],
        expertiseType: [],
        expertiseSubType: [],
        expertiseStatus: [],
        experts: []
      };
      this.fetchExpertise();
    },

    getLinkExpertise() {
      ExpertiseService.getLinkReestrExpertise(this.listConfig).then(
        ({ data }) => {
          window.open(
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
            "_blank"
          );
        }
      );
    },

    fetchExpertise() {
      this.$store
        .dispatch(FETCH_ALL_EXPERTISES_LIST, this.listConfig)
        .then(() => {
          if (this.allExpertises.SETTINGS) {
            this.isLoaded = true;
          }

          // 3 условия для фильтров по умолчанию
          if (this.allExpertises.SETTINGS.DEFAULT_PHILTER_TYPE.length) {
            const arr = this.allExpertises.SETTINGS.TYPE_SP.filter(el =>
              this.allExpertises.SETTINGS.DEFAULT_PHILTER_TYPE.includes(el.ID)
            );
            this.filter.expertiseType = [...this.filter.expertiseType, ...arr];
          }

          if (this.allExpertises.SETTINGS.DEFAULT_PHILTER_SUBTYPE.length) {
            const arr = this.allExpertises.SETTINGS.SUBTYPE_SP.filter(el =>
              this.allExpertises.SETTINGS.DEFAULT_PHILTER_SUBTYPE.includes(
                el.ID
              )
            );
            this.filter.expertiseType = [...this.filter.expertiseType, ...arr];
          }

          if (this.allExpertises.SETTINGS.DEFAULT_PHILTER_STATUS.length) {
            const arr = this.allExpertises.SETTINGS.STATUS_SP.filter(el =>
              this.allExpertises.SETTINGS.DEFAULT_PHILTER_STATUS.includes(el.ID)
            );
            this.filter.expertiseStatus = [
              ...this.filter.expertiseStatus,
              ...arr
            ];
          }

          if (this.allExpertises.SETTINGS.DEFAULT_PHILTER_EXPERT.length) {
            const arr = this.allExpertises.SETTINGS.EXPERTS_SP.filter(el =>
              this.allExpertises.SETTINGS.DEFAULT_PHILTER_EXPERT.includes(el.ID)
            );
            this.filter.experts = [...this.filter.experts, ...arr];
          }

          if (
            this.allExpertises.SETTINGS.IS_VIEW_PHILTER_MANAGER_OSP &&
            this.allExpertises.SETTINGS.DEFAULT_PHILTER_MANAGER_OSP.length
          ) {
            const arr = this.allExpertises.SETTINGS.MANAGER_OSP_LIST.filter(
              el =>
                this.allExpertises.SETTINGS.DEFAULT_PHILTER_MANAGER_OSP.includes(
                  el.ID
                )
            );
            this.filter.manager_osp = [...this.filter.manager_osp, ...arr];
          }
        });
    },

    in_array(idFind, a) {
      return a.filter(function(item) {
        return item == idFind;
      }).length
        ? true
        : false;
    },

    viewRequestByProject(id) {

      const q = {
        page: 1,
        limit: 1000
      };
      const f = {
        UF_PROJECT_ID: id,
        isSetPhilterUser: 1
      };

      this.$store
        .dispatch(FETCH_REQUESTS, {
          ...q,
          filter: { ...f }
        })
        .then(() => {
          this.isViewRequestInfo = true;
        });

    }
  }
};
</script>
